import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ArrowUpRight, AlertTriangle, Ban, Unlock } from "lucide-react";

export const taskLink = (i) => {
  const q = new URLSearchParams();
  if (i.phase_id) q.set("phase", i.phase_id);
  if (i.action_id) q.set("action", i.action_id);
  const s = q.toString();
  return `/projects/${i.project_id}${s ? `?${s}` : ""}`;
};

export const TaskItem = ({ item, testid }) => (
  <Link to={taskLink(item)} className="row-hover block rounded-lg border border-slate-200 bg-white p-4" data-testid={testid}>
    <div className="flex items-center gap-4">
      <span className="font-mono text-xs text-slate-500 bg-slate-100 rounded px-2 py-1 shrink-0">{item.project_number}</span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-slate-900 truncate">{item.title || item.project_title}</div>
        <div className="text-xs text-slate-500 truncate">
          {item.customer_name} · {item.brand}{item.phase_name ? ` · ${item.phase_name}` : ""}{item.owner_name ? ` · ${item.owner_name}` : ""}
        </div>
      </div>
      <div className="hidden md:flex items-center gap-2 shrink-0">
        {item.kind === "action" && item.mandatory && <Badge variant="outline" className="text-[10px] uppercase">Mandatory</Badge>}
        {item.kind === "phase" && <Badge className="bg-red-100 text-red-700 hover:bg-red-100"><Ban className="h-3 w-3 mr-1" />{item.open_blockers} open</Badge>}
        {item.kind === "project" && item.erp_ready && <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100"><Unlock className="h-3 w-3 mr-1" />ERP ready</Badge>}
        {item.kind === "project" && !item.erp_ready && <span className="font-mono text-xs text-slate-500">{item.readiness_pct}%</span>}
        {item.blocked && item.kind === "project" && <Badge className="bg-red-100 text-red-700 hover:bg-red-100">Blocked</Badge>}
      </div>
      <div className="w-28 text-right shrink-0">
        {item.due_date ? (
          <span className={`font-mono text-xs ${item.overdue ? "text-red-600 font-semibold" : "text-slate-600"}`}>
            {item.overdue && <AlertTriangle className="inline h-3 w-3 mr-1" />}{item.due_date}
          </span>
        ) : <span className="text-xs text-slate-400">no due</span>}
      </div>
      <ArrowUpRight className="h-4 w-4 text-slate-400" />
    </div>
  </Link>
);
